import React from 'react'
import { StyleSheet, Text, View, TextInput } from 'react-native';

export default function MyInput(props) {
    function handleChange(event) {
      // Here, we invoke the callback with the new value
      props.onChange(event.target.value);
    }
    
    return <TextInput value={props.value} placeholder="he;lllllllll" onChange={handleChange} />
  }

const styles = StyleSheet.create({})
